import { render, staticRenderFns } from "./undeliveredshipmentstatus.vue?vue&type=template&id=fd677054"
import script from "./undeliveredshipmentstatus.vue?vue&type=script&lang=js"
export * from "./undeliveredshipmentstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports